module.exports = __webpack_public_path__ + "img/vedio_des_3.01349c1e.jpg";